var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.5 32",
    style: {
      enableBackground: "new 0 0 129.5 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#373838;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,24.6l3.2,4.1h-2.7l-2.2-2.8c-1.8,1.1-3.8,1.7-6,1.7c-3.2,0-6-1.1-8.2-3.3S41,19.2,41,16.1 c0-2.1,0.5-4.1,1.5-5.9c1-1.8,2.4-3.2,4.2-4.2s3.7-1.5,5.8-1.5c3.2,0,6,1.1,8.2,3.3C62.9,10,64,12.8,64,16c0,1.7-0.3,3.2-0.9,4.6 C62.5,22,61.6,23.3,60.3,24.6z M58.9,22.9c1.9-1.9,2.9-4.1,2.9-6.9c0-1.7-0.4-3.3-1.2-4.7c-0.8-1.4-1.9-2.5-3.4-3.4 c-1.5-0.8-3-1.3-4.6-1.3c-1.6,0-3.2,0.4-4.6,1.3c-1.4,0.8-2.6,2-3.4,3.4c-0.8,1.4-1.2,3-1.2,4.8c0,2.6,0.9,4.8,2.7,6.6 c1.8,1.8,4,2.7,6.5,2.7c1.7,0,3.3-0.4,4.8-1.3l-4.9-6.2H55L58.9,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,10.8h2.5l4.3,5.9l4.3-5.9h2.5l-5.5,7.6l6.2,8.5H78l-4.9-6.8l-4.9,6.8h-2.5l6.1-8.5L66.3,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.1,26.9l3.1-21.9h0.4l8.9,18l8.8-18h0.4l3.1,21.9h-2.1l-2.2-15.7l-7.7,15.7h-0.6l-7.8-15.8l-2.1,15.8H82.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.1,26.9V5.1h4.5c3.3,0,5.6,0.3,7.1,0.8c2.1,0.7,3.8,2,5,3.9s1.8,4,1.8,6.6c0,2.2-0.5,4.1-1.4,5.8 c-0.9,1.7-2.2,2.9-3.7,3.7s-3.6,1.2-6.4,1.2H111.1z M113.2,24.9h2.5c3,0,5.1-0.2,6.3-0.6c1.6-0.5,2.9-1.5,3.9-2.9 c0.9-1.4,1.4-3.1,1.4-5.1c0-2.1-0.5-3.9-1.5-5.4c-1-1.5-2.4-2.5-4.3-3.1c-1.4-0.4-3.6-0.6-6.8-0.6h-1.5V24.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,1.2C4,3.7,0,9.4,0,16c0,2.7,0.7,5.3,1.9,7.5H19L9.8,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,25H2.8c2.9,4.2,7.7,7,13.2,7c2.1,0,4.2-0.4,6-1.2L19.6,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0c-1.7,0-3.3,0.3-4.8,0.7l9.4,22.8h9.5c1.2-2.2,1.9-4.8,1.9-7.5C32,7.2,24.8,0,16,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.8,26.6 29.1,25.1 29.1,25 29.1,25 21.3,25 24.2,32 32,32  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e7dd8b00ee2bde3fb6717fbd97e7da39.svg";
export { ForwardRef as ReactComponent };